import styled from '@emotion/styled';
import {
  ListItemButton,
  ListItemButtonProps
} from '@portalterreno/react-ui-core/List';

export type StyledListItemProps = ListItemButtonProps;

const StyledListItem = styled(ListItemButton)<StyledListItemProps>(
  {
    'alignItems': 'center',
    'display': 'inline-flex',
    'height': '35px',
    'justifyContent': 'flex-start',
    'padding': '0',
    'width': '100%',
    'p': {
      marginLeft: 10
    },
    '&:hover': {
      backgroundColor: 'inherit'
    }
  },
  ({ theme: { typography, palette } }) => ({
    fontSize: typography.fontSize.medium,
    color: palette.colors.midnightBlue
  })
);

export default StyledListItem;
